import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Divider, Grid, Checkbox, FormControlLabel } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

import {getListAPI} from '../../../components/pmorder/PmorderAPI';
import { setCompleteTaskButtonEnabled } from "store/slice/AppSlice";
import ProductInfo from "./ProductInfo";

export default function TaskSpaceProdPrimaryPackaging() {
  const dispatch = useDispatch();
  const [pmorderList, setPmorderList] = React.useState([]);
  const [pmorderObj, setPmorderObj] = React.useState({});
  const [confirmed, setConfirmed] = useState(false);
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const {taskApiResponse} = useSelector((state) => state.appslice.wkflow); 

  useEffect(() => {
    getListAPI(setPmorderList, ()=>{});

  }, []);

  useEffect(() => {
    pmorderList.find((pmorder) => {
      if (pmorder.productid === productObj.id) {
        setPmorderObj(pmorder);
        return true;
      }
      return false;
    });
    
  },[pmorderList, productObj.id]);

  const handleCheckboxChange = (e) => {
    setConfirmed(e.target.checked);
    dispatch(setCompleteTaskButtonEnabled(e.target.checked));
  };

  return (
    <Grid item lg={12} md={12} sm={12} xs={12} >
            <Grid container sx={{ width: '100%' }}>
              <Grid item lg={4} md={4} sm={4} xs={12}>
                <ProductInfo productId={productObj.id} />
              </Grid>
              <Grid item lg={8} md={8} sm={8} xs={12} sx={{pt:2}}>
                
                <Box sx={{ backgroundColor: "white", borderRadius: 2, p: 3, boxShadow: 1 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={confirmed}
                        onChange={handleCheckboxChange}
                        color="primary"
                        disabled={taskApiResponse && taskApiResponse.success !== undefined}
                      />
                    }
                    label="I confirm that Primary Packaging for this Product is done. It is ready for QA Testing."
                  />
                </Box>
                </Grid>
      </Grid>
    </Grid>
  );
}